//Why I have Created Different Js File is that, Members may or may not be the Connected Peoples so That I have Changed
import React, { useContext, useState, useEffect } from 'react';
import {
    Button, TextField, IconButton, Box, Checkbox, Menu, MenuItem, Avatar, Dialog,
    DialogTitle, Typography, DialogContent, Grid, Switch, DialogActions,
    Tooltip
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDragUploadImage from '../../../Utilities/FileDragUploadImage';
import { ContactsDetContext } from '../../../ContactsDetContext';
import useApi from '../../../Utilities/useAPI';
import VerifiedIcon from '@mui/icons-material/Verified';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getContactGroupReducer, postEditContactGroupReducer } from '../../../../Redux/Reducers/ContactReducer';
import { useDispatch } from 'react-redux';
import { useQuantityContext } from '../../../QuantityContext';

const CreateGroupForm = () => {
    const { groupDetailsEdit, setGroupDetailsEdit } = useContext(ContactsDetContext);
    const apiKey = process.env.REACT_APP_API_KEY
    const objectId = localStorage.getItem("objectId");

    const dispatch = useDispatch();
    const { handleInfo } = useQuantityContext();
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };
    const { callApiFunction } = useApi();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setGroupDetailsEdit((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        // Check if 'openDialog' is passed in location state and open the dialog
        if (location.state?.openDialog) {
            setIsDialogOpen(true);
        }
    }, [location.state]);

    useEffect(() => {
        if (!groupDetailsEdit?.is_editable) {
            navigate(-1);
        }
    }, []);



    const EditGroup = async () => {
        try {
            // Step 1: Map the members to only include the contact_ref_id
            const updatedMembers = groupDetailsEdit?.members?.map(member => member?.contact_ref_id);
            // Step 2: Create the updated payload with the transformed members array
            const updatedGroupDetails = {
                ...groupDetailsEdit,
                members: updatedMembers
            };


            const formData = new FormData();
            formData.append('group_name', groupDetailsEdit?.group_name);
            formData.append('group_type', groupDetailsEdit?.group_type);
            formData.append('group_category', groupDetailsEdit?.group_category)
            formData.append('group_subname', groupDetailsEdit?.group_subname)
            formData.append('group_desc', groupDetailsEdit?.group_desc)
            formData.append('group_id', groupDetailsEdit?.group_id);
            if (groupDetailsEdit?.group_image) {
                setLoading(true);
                handleInfo("Please wait to complete the process.");
                try {
                    const response = await fetch(groupDetailsEdit?.group_image);
                    const blob = await response.blob();
                    formData.append('profile_pic', blob);
                } catch (error) {
                    console.log("Error", error);
                }

                setLoading(false);
            }

            // const updatedMembers = groupDetailsEdit.members.map(member => member.contact_ref_id);
            if (groupDetailsEdit?.members) {
                groupDetailsEdit?.members?.forEach(member => {
                    formData.append('members[]', member?.contact_ref_id);
                });
            }
            // console.log("123456POST",Object.fromEntries(formData.entries()));
            const response = await dispatch(postEditContactGroupReducer(formData))
            //  callApiFunction('editGroupDetails', updatedGroupDetails);

            if (response?.payload?.data?.statusCode === 200) {
                // console.log("Group Created Successfully");
                await dispatch(getContactGroupReducer());
                navigate("/contacts")
            }
        }
        catch (error) {
            console.log('Error:', error);
        }
    }
    // To track the hovered contact
    const [hoveredContact, setHoveredContact] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRemoveAllContacts = () => {
        setGroupDetailsEdit((prevDetails) => ({
            ...prevDetails,
            members: [],  // Clear all group members
        }));
    };

    const handleRemoveContact = (userRefId) => {
        // Remove the contact from groupDetails' members array based on contact_ref_id
        setGroupDetailsEdit((prevDetails) => ({
            ...prevDetails,
            members: prevDetails?.members?.filter((member) => member?.contact_ref_id !== userRefId), // Remove the specific member
        }));
    };
    const isButtonDisabled = !groupDetailsEdit?.group_name || !groupDetailsEdit?.group_image || groupDetailsEdit?.members?.length === 0;

    const handleDeleteGroup = async () => {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/usercontact/groups/deleteGroup/${groupDetailsEdit?.group_id}`,
            { headers } // Pass headers if required
        );

        if (response?.status === 200) {
            navigate("/contacts")
            // Handle successful deletion (maybe refresh data or navigate back)
        } else {
            console.error('Failed to delete group:', response?.data);
        }
    }
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleOpen = () => {

        setIsDialogOpen(true);
        // const { openDialog } = location.state || {};

    };

    const handleClosePermissions = () => {
        setIsDialogOpen(false);
    };

    const [adminPermissions, setAdminPermissions] = useState({
        canEditGroup: false,
        onlyAdminsCommunicate: false,
        viewProfile: false,
        manageContacts: false,
        muteNotifications: false,
        sendInvitation: false
    });

    const handleSwitchChange = (event) => {
        setAdminPermissions({
            ...adminPermissions,
            [event.target.name]: event.target.checked
        });
    };

    const handleReset = () => {
        setAdminPermissions({
            canEditGroup: false,
            onlyAdminsCommunicate: false,
            viewProfile: false,
            manageContacts: false,
            muteNotifications: false,
            sendInvitation: false
        });
    };

    const handleSave = async () => {
        try {
            const updatedAdminMembers = groupDetailsEdit?.admins?.map(member => member?.contact_ref_id);

            // Step 4: Prepare the payload for the second API call
            const roleAssignmentPayload = {
                group_id: groupDetailsEdit?.group_id,
                members: updatedAdminMembers
            };

            // Step 5: Call the second API to assign roles
            await callApiFunction('assignRoleAdminGroup', roleAssignmentPayload);

            // if (roleResponse?.statusCode === 200) {
            //     toast.success('Admin Updated Successfully!');
            // }
        } catch (error) {
            // toast.error('Something Went Wrong');
            console.log('Something Went Wrong')
        } finally {
            handleClosePermissions(); // Ensure the dialog closes after the operation
        }
    };

    const handleAddAdminClick = () => {
        navigate('/addadminEditGroup');
    };
    return (
        <div className="outer-layer-of-contacts" style={{ position: 'relative' }}>
            <div className="outer-container">
                <div className='d-flex justify-content-between'>
                    <h5 className='fw-bold' style={{ fontSize: "18px" }}>Edit Group Contacts</h5>
                    <div className='d-flex align-items-center gap-2 icon-color pointer' onClick={handleDeleteGroup}>
                        <DeleteIcon className='icon-color' /> Delete
                    </div>
                </div>
                <div className='sub-text-lightbox'>Edit new group to manage profiles and teams</div>
                <div className="mt-4 group-card-creation p-3">
                    <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                        {/* First Column - 75% */}
                        <Box flex="0 0 85%" pr={2}>
                            <h5 className='mb-3' style={{ fontSize: "18px" }}>Group Information</h5>
                            <Box display="flex" flexWrap="wrap" gap={2}>
                                <Box flex="1 1 48%">
                                    <TextField
                                        fullWidth
                                        label="Group Name"
                                        name="group_name"
                                        placeholder="e.g. Product Team"
                                        variant="outlined"
                                        value={groupDetailsEdit?.group_name}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 24 }}
                                        required
                                    />
                                </Box>
                                <Box flex="1 1 48%">
                                    <TextField
                                        fullWidth
                                        label="Sub Name"
                                        name="group_subname"
                                        placeholder="e.g. Software Department"
                                        variant="outlined"
                                        value={groupDetailsEdit?.group_subname}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 24 }}
                                    />
                                </Box>
                            </Box>

                            <Box mt={2}>
                                <TextField
                                    fullWidth
                                    label="Group Description"
                                    name="group_desc"
                                    placeholder="Write group description"
                                    variant="outlined"
                                    value={groupDetailsEdit?.group_desc}
                                    onChange={handleChange}
                                />
                            </Box>
                        </Box>

                        {/* Second Column - 25% */}
                        <Box flex="0 0 15%" display="flex" flexDirection="column" alignItems="center">
                            <div className='sub-heading-style mb-2'>
                                Add Group Image*
                            </div>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%"
                                width="100%"
                                style={{ cursor: 'pointer' }}
                            >
                                <FileDragUploadImage stateOfData={groupDetailsEdit} setStateOfData={setGroupDetailsEdit} contextKey="group_image" accept={['image/jpeg', 'image/png']} maxSize={5} inputId="group-Image-Input" />
                            </Box>
                        </Box>
                    </Box>
                </div>
                <div className="mt-4 group-card-creation p-3">
                    <div className="d-flex align-items-center justify-content-between">
                        <h6 style={{ fontSize: "18px" }}>Add to Group</h6>
                        {groupDetailsEdit?.members?.length > 0 && <div>
                            <IconButton
                                id="more-button"
                                aria-controls={open ? 'long-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                id="long-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <MenuItem style={{ fontSize: '14px' }} onClick={() => {
                                    handleRemoveAllContacts();
                                    handleClose();
                                }}>
                                    Remove All
                                </MenuItem>
                            </Menu>
                        </div>}
                    </div>
                    {groupDetailsEdit?.members?.length > 0 ? (
                        <div className='d-flex align-items-center justify-content-start me-3 gap-3 p-2 flex-wrap member-details-group'>
                            {groupDetailsEdit?.members?.map((contact) => (
                                <div
                                    key={contact?.contact_ref_id}
                                    className='group-create-addMore group-card-creation flex-center flex-column gap-2 flex-wrap'
                                    onMouseEnter={() => setHoveredContact(contact?.contact_ref_id)}
                                    onMouseLeave={() => setHoveredContact(null)}
                                >
                                    {/* Show Remove Icon on Hover */}
                                    {hoveredContact === contact?.contact_ref_id && (
                                        <div className='w-100 h-100 flex-center' style={{
                                            position: 'absolute',
                                            backgroundColor: '#FFFFFFEB',
                                            borderRadius: '8px',
                                            zIndex: "1000",
                                            border: "1px solid #0044c6"
                                        }}>
                                            <div className='d-flex align-items-center'
                                                onClick={() => handleRemoveContact(contact?.contact_ref_id)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <DeleteIcon className='icon-color' />
                                                <span className='ms-2' style={{ color: '#00000099', fontSize: '14px' }}>Remove</span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="dot_status_contacts">
                                        <Checkbox
                                            checked={true}
                                            className="member-checkbox p-0"
                                        />
                                    </div>
                                    <div style={{ height: "60px", position: 'relative' }}>
                                        <div className="avatar-image t smaller-screen-avartar">
                                            {/* <img className='cover-image' src={contact.img} alt={contact.name} /> */}
                                            <Avatar style={{ fontSize: "2rem" }}
                                                className="w-100 h-100 cover-image"
                                                alt={contact?.name}
                                                src={contact?.img || undefined}
                                            >{contact?.name?.charAt(0).toUpperCase()}
                                            </Avatar>
                                        </div>
                                        <div className={`symbol_of_contacts compact`}>
                                            {contact?.verified ?
                                                <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                <NonVerifiedTickNew />
                                            }
                                        </div>
                                    </div>
                                    <div className='flex-center flex-column'>
                                        <div className='three-rows-text text-center'>{contact?.name}</div>
                                        <div className='designation-sub-heading-style-14'>{contact?.role}</div>
                                    </div>
                                </div>
                            ))}
                            <Link to="/addPeopletoGroup">
                                <div className='group-create-addMore group-card-creation flex-center'>
                                    <div className='flex-center flex-column'>
                                        <IconButton sx={{ color: '#0044C6' }}>
                                            <AddCircleRoundedIcon />
                                        </IconButton>
                                        <div>Add Contacts</div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ) : (
                        <div className='flex-center'>
                            <Link to="/addPeopletoGroup">
                                <div className='group-create-addMore group-card-creation flex-center'>
                                    <div className='flex-center flex-column'>
                                        <IconButton sx={{ color: '#0044C6' }}>
                                            <AddCircleRoundedIcon />
                                        </IconButton>
                                        <div>Add Contacts</div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )}
                </div>

                <div className='mt-3 d-flex align-items-center justify-content-between'>
                    <div
                        className={`d-flex align-items-center ${isButtonDisabled ? 'disabled' : ''}`}
                        onClick={!isButtonDisabled ? handleOpen : null}
                        style={{ cursor: isButtonDisabled ? 'not-allowed' : 'pointer' }}>
                        <IconButton sx={{ color: isButtonDisabled ? '#B0B0B0' : '#0044C6' }} disabled={isButtonDisabled}>
                            <AddCircleRoundedIcon />
                        </IconButton>
                        <div className={isButtonDisabled ? 'color-grey' : 'color-blue'}>
                            Permissions & Access Control
                        </div>
                    </div>
                    <Button className='me-2' sx={{ color: 'ehite', backgroundColor: "#0044c6" }} variant="contained" disabled={isButtonDisabled} onClick={EditGroup}>SAVE GROUP</Button>
                </div>

                <Dialog open={isDialogOpen} onClose={handleClosePermissions} fullWidth maxWidth="sm" sx={{ overflow: 'hidden' }}>
                    <DialogTitle className='pb-0'>
                        <Typography variant="h6" className="heading-Lightbox-group">Permissions & Access Control</Typography>
                        <Typography className='mt-0 mb-4 group_permissions_subtitle' sx={{ fontSize: "12px" }}>Manage who can access what</Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleClosePermissions}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent className="pb-0">
                        <Box mb={3}>
                            <Typography className='group_permissions_subtitle mb-1'>Admin Management</Typography>


                            <div className='d-flex align-items-center justify-content-start gap-3 flex-wrap member-details-group'>
                                {groupDetailsEdit?.admins?.map((contact) => (
                                    <div key={contact?.contact_ref_id}
                                        className='group-create-addMore group-card-creation flex-center flex-column gap-2'
                                    >
                                        <div style={{ height: "60px", position: 'relative' }}>
                                            <div className="avatar-image t smaller-screen-avartar">
                                                {/* <img className='cover-image' src={contact.img} alt={contact.name} /> */}
                                                <Avatar style={{ fontSize: "2rem" }}
                                                    className="w-100 h-100 cover-image"
                                                    alt={contact?.name}
                                                    src={contact?.img || undefined}
                                                >{contact.name.charAt(0).toUpperCase()}
                                                </Avatar>
                                            </div>
                                            <div className={`symbol_of_contacts compact`}>
                                                {contact?.verified ?
                                                    <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                    <NonVerifiedTickNew />
                                                }
                                            </div>
                                        </div>
                                        <div className='flex-center flex-column'>

                                            <Tooltip title={contact?.name} placement="bottom">
                                                <div className="member-name">
                                                    {contact?.name?.length > 10
                                                        ? `${contact?.name.slice(0, 10)}...`
                                                        : contact?.name}
                                                </div>
                                            </Tooltip>
                                            {/* <div className='Smaller-Heading-groupMem'>{contact.name}</div> */}
                                            <Tooltip title={contact?.role} placement="bottom">
                                                <div className="sub-heading-style-14">
                                                    {contact?.role?.length > 10
                                                        ? `${contact?.role.slice(0, 10)}...`
                                                        : contact?.role}
                                                </div>
                                            </Tooltip>
                                            {/* <div className='sub-heading-style-14'>{contact.role}</div> */}
                                        </div>
                                    </div>
                                ))}
                                {/* it is needed */}
                                <Link to={`/addadminEditGroup?groupName=true`}>
                                    <div className='group-create-addMore group-card-creation flex-center mb-2'>
                                        <div className='flex-center flex-column'>
                                            <IconButton sx={{ color: '#0044C6' }}>
                                                <AddCircleRoundedIcon />
                                            </IconButton>
                                            <div>Add Admin</div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </Box>

                        <Box mb={3}>
                            <Typography className='group_permissions_subtitle'>
                                Admin Permissions (Verified Users Only)
                            </Typography>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">Admin can edit group details and add new members.</Typography>
                                <Switch
                                    checked={adminPermissions?.canEditGroup}
                                    onChange={handleSwitchChange}
                                    name="canEditGroup"
                                />
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">Only Admins Can Communicate</Typography>
                                <Switch
                                    checked={adminPermissions?.onlyAdminsCommunicate}
                                    onChange={handleSwitchChange}
                                    name="onlyAdminsCommunicate"
                                />
                            </Grid>
                        </Box>

                        <Box mb={3}>
                            <Typography className='group_permissions_subtitle'>
                                Other Members Permissions (Verified Users Only)
                            </Typography>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">View Profile</Typography>
                                <Switch
                                    checked={adminPermissions?.viewProfile}
                                    onChange={handleSwitchChange}
                                    name="viewProfile"
                                />
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">Manage Contacts</Typography>
                                <Switch
                                    checked={adminPermissions?.manageContacts}
                                    onChange={handleSwitchChange}
                                    name="manageContacts"
                                />
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">Mute Notifications</Typography>
                                <Switch
                                    checked={adminPermissions?.muteNotifications}
                                    onChange={handleSwitchChange}
                                    name="muteNotifications"
                                />
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Typography className="group_permissiions_options">Send Invitation</Typography>
                                <Switch
                                    checked={adminPermissions?.sendInvitation}
                                    onChange={handleSwitchChange}
                                    name="sendInvitation"
                                />
                            </Grid>
                        </Box>
                    </DialogContent>

                    <DialogActions className="pe-4 pb-4">
                        <Button onClick={handleReset} style={{ color: "#0044c6" }}>
                            Reset
                        </Button>
                        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: "#0044C6" }}>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default CreateGroupForm;